// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-primary: #6a11cb;
  --color-success: #00b09b;
  --color-danger: #ff5858;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-primary);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  line-height: 1.6;
}

.partner_labour_main_container {
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
}

.partner_labour_header {
  position: relative;
  text-align: center;
  margin-bottom: 1rem;
  padding: 1rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}
.partner-header-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.Partner-animated-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: landFloat 6s ease-in-out infinite;
}

.Partner-shape-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.Partner-shape-2 {
  width: 150px;
  height: 150px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.Partner-shape-3 {
  width: 80px;
  height: 80px;
  bottom: 30%;
  left: 20%;
  animation-delay: 4s;
}

.Partner-shape-4 {
  width: 120px;
  height: 120px;
  top: 10%;
  right: 30%;
  animation-delay: 1s;
}

/* @keyframes landFloat {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
} */
.partner_header_content {
  position: relative;
  z-index: 2;
}

.partner_header_decoration {
  position: absolute;
  top: -50%;
  right: -10%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

/* @keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
} */

.partner_labour_title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.partner_labour_subtitle {
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 300;
}

.Partner_search_add_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.Partner_search_container {
  flex: 1 1;
  min-width: 200px;
}

.partner_search_input_wrapper {
  position: relative;
  max-width: 600px;
}

.partner_search_icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: var(--color-text-tertiary);
}

.partner_search_input {
  width: 100%;
  padding: 0.8rem 1rem 0.8rem 2.5rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  background: var(--color-bg-primary);
  transition: var(--transition-normal);
}

.partner_search_input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.Partner_add_container {
  flex-shrink: 0;
}

.Partner_add_button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.2rem;
  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
  color: white;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
  background: #f97316;
}

.Partner_add_button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.partner_add_icon {
  width: 16px;
  height: 16px;
}

.Partner_registration_form_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(5px);
}

.Partner_registration_form {
  background: var(--color-bg-primary);
  padding: 1.5rem;
  border-radius: var(--border-radius-md);
  width: 100%;
  max-width: 600px;
  box-shadow: var(--shadow-lg);
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

.Partner_registration_form_close_button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: var(--color-danger);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition-fast);
}

.Partner_registration_form_close_button:hover {
  background: #d32f2f;
  transform: scale(1.1);
}

.Partner_registration_form_close_button svg {
  width: 14px;
  height: 14px;
}

.partner_form_header {
  text-align: center;
  margin-bottom: 1rem;
}

.partner_form_title {
  font-size: 1.5rem;
  font-weight: 600;
}

.partner_form_subtitle {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

.form_grid_container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.Partner_registration_form_label {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.partner_label_text {
  font-size: 0.85rem;
  font-weight: 500;
}

.Partner_registration_form_input {
  padding: 0.7rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.9rem;
  background: var(--color-bg-secondary);
  transition: var(--transition-fast);
}

.Partner_registration_form_input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.Partner_registration_submit_button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.8rem;
  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */
  background-color: #f97316;
  color: white;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition-normal);
  box-shadow: var(--shadow-sm);
  margin-top: 8px;
}

.Partner_registration_submit_button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.partner_submit_icon {
  width: 16px;
  height: 16px;
}

.partner_loading_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  text-align: center;
}

.partner_loading_spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--color-border);
  border-top: 3px solid var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 0.5rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.partner_loading_text {
  font-size: 0.9rem;
  color: var(--color-text-secondary);
}

.partner_table_wrapper {
  overflow-x: auto;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--color-border);
}

.partner_table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.partner_table th,
.partner_table td {
  border-bottom: 1px solid var(--color-border);
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid var(--task-border-color);
}

.partner_table th {
  background: var(--color-bg-secondary);
  font-weight: 600;
  color: var(--color-text-primary);
}

.partner_table tr:hover {
  background: var(--color-bg-tertiary);
}

.partner_status_badge {
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.partner_status_badge.active {
  background: rgb(249 115 22);
  color: #fdfdfd;
}

.partner_status_badge.blocked {
  background: rgba(255, 88, 88, 0.1);
  color: var(--color-danger);
}

.partner_action_buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.partner_action_button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.85rem;
  font-weight: 500;
  transition: var(--transition-fast);
}

.partner_action_button svg {
  width: 14px;
  height: 14px;
}

.partner_edit_button {
  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
  color: #f97316;
  border: 1px solid #f97316;
}

.partner_edit_button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.partner_block_button {
  color: #f97316;
  border: 1px solid #f97316;
}
.partner_unblock_button {
  /* background: var(--color-danger);
  color: white; */
  color: #f97316;
  border: 1px solid #f97316;
}

.partner_unblock_button {
  /* background: var(--color-success); */
}

.partner_block_button:hover,
.partner_unblock_button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.partner_no_results {
  text-align: center;
  padding: 2rem;
  color: var(--color-text-secondary);
  font-size: 0.95rem;
}

.partner_avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  margin-right: 0.5rem;
  text-transform: uppercase;
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: var(--shadow-sm);
}

.partner_name_container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.partner_name_text {
  font-weight: 500;
  font-size: 0.9rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .partner_table th,
  .partner_table td {
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid var(--task-border-color);
  }

  .partner_action_buttons {
    flex-direction: column;
    align-items: flex-start;
  }

  .partner_action_button {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .partner_labour_main_container {
    padding: 0.5rem;
  }

  .partner_labour_title {
    font-size: 1.5rem;
  }

  .partner_labour_subtitle {
    font-size: 0.9rem;
  }

  .Partner_search_add_container {
    flex-direction: column;
    align-items: stretch;
  }

  .form_grid_container {
    grid-template-columns: 1fr;
  }

  .Partner_registration_form {
    margin: 0.5rem;
    padding: 1rem;
  }

  .partner_table {
    font-size: 0.8rem;
  }

  .partner_table th,
  .partner_table td {
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid var(--task-border-color);
  }

  .partner_table th:nth-child(4),
  .partner_table td:nth-child(4),
  .partner_table th:nth-child(5),
  .partner_table td:nth-child(5) {
    display: none;
  }
}

@media (max-width: 480px) {
  .partner_labour_title {
    font-size: 1.3rem;
  }

  .partner_labour_subtitle {
    font-size: 0.85rem;
  }

  .partner_search_input {
    padding: 0.6rem 0.6rem 0.6rem 2rem;
    font-size: 0.85rem;
  }

  .Partner_add_button {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }

  .partner_table th,
  .partner_table td {
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid var(--task-border-color);
  }

  .partner_table th:nth-child(2),
  .partner_table td:nth-child(2) {
    display: none;
  }

  .partner_action_button {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
  }
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.Partner_registration_form_input.password-input {
  padding-right: 2.5rem;
  width: 100%;
}

.password-toggle-button {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

.password-toggle-icon {
  color: #6b7280;
  transition: color 0.2s ease;
}

.password-toggle-button:hover .password-toggle-icon {
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/labour/labour.css"],"names":[],"mappings":"AAAA;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;;;;GAQG;AACH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;;;;;;;GAQG;;AAEH;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,iBAAiB;EACjB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mEAAmE;EACnE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,sCAAsC;EACtC,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mEAAmE;EACnE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;iBACe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,aAAa;IACb,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;;;;IAIE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;IACb,kBAAkB;IAClB,iDAAiD;EACnD;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":[":root {\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-primary: #6a11cb;\n  --color-success: #00b09b;\n  --color-danger: #ff5858;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-primary);\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n}\n\n.partner_labour_main_container {\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: 100vh;\n}\n\n.partner_labour_header {\n  position: relative;\n  text-align: center;\n  margin-bottom: 1rem;\n  padding: 1rem 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n}\n.partner-header-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n.Partner-animated-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: landFloat 6s ease-in-out infinite;\n}\n\n.Partner-shape-1 {\n  width: 100px;\n  height: 100px;\n  top: 20%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.Partner-shape-2 {\n  width: 150px;\n  height: 150px;\n  top: 60%;\n  right: 15%;\n  animation-delay: 2s;\n}\n\n.Partner-shape-3 {\n  width: 80px;\n  height: 80px;\n  bottom: 30%;\n  left: 20%;\n  animation-delay: 4s;\n}\n\n.Partner-shape-4 {\n  width: 120px;\n  height: 120px;\n  top: 10%;\n  right: 30%;\n  animation-delay: 1s;\n}\n\n/* @keyframes landFloat {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n} */\n.partner_header_content {\n  position: relative;\n  z-index: 2;\n}\n\n.partner_header_decoration {\n  position: absolute;\n  top: -50%;\n  right: -10%;\n  width: 200px;\n  height: 200px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  animation: float 6s ease-in-out infinite;\n}\n\n/* @keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-20px) rotate(180deg);\n  }\n} */\n\n.partner_labour_title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.partner_labour_subtitle {\n  font-size: 1rem;\n  opacity: 0.9;\n  font-weight: 300;\n}\n\n.Partner_search_add_container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.Partner_search_container {\n  flex: 1;\n  min-width: 200px;\n}\n\n.partner_search_input_wrapper {\n  position: relative;\n  max-width: 600px;\n}\n\n.partner_search_icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 18px;\n  height: 18px;\n  color: var(--color-text-tertiary);\n}\n\n.partner_search_input {\n  width: 100%;\n  padding: 0.8rem 1rem 0.8rem 2.5rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  background: var(--color-bg-primary);\n  transition: var(--transition-normal);\n}\n\n.partner_search_input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.Partner_add_container {\n  flex-shrink: 0;\n}\n\n.Partner_add_button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.8rem 1.2rem;\n  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  background: #f97316;\n}\n\n.Partner_add_button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.partner_add_icon {\n  width: 16px;\n  height: 16px;\n}\n\n.Partner_registration_form_container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(5px);\n}\n\n.Partner_registration_form {\n  background: var(--color-bg-primary);\n  padding: 1.5rem;\n  border-radius: var(--border-radius-md);\n  width: 100%;\n  max-width: 600px;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.Partner_registration_form_close_button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: var(--color-danger);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.Partner_registration_form_close_button:hover {\n  background: #d32f2f;\n  transform: scale(1.1);\n}\n\n.Partner_registration_form_close_button svg {\n  width: 14px;\n  height: 14px;\n}\n\n.partner_form_header {\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.partner_form_title {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.partner_form_subtitle {\n  font-size: 0.9rem;\n  color: var(--color-text-secondary);\n}\n\n.form_grid_container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.Partner_registration_form_label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.partner_label_text {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.Partner_registration_form_input {\n  padding: 0.7rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.9rem;\n  background: var(--color-bg-secondary);\n  transition: var(--transition-fast);\n}\n\n.Partner_registration_form_input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.Partner_registration_submit_button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.8rem;\n  /* background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%); */\n  background-color: #f97316;\n  color: white;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  margin-top: 8px;\n}\n\n.Partner_registration_submit_button:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.partner_submit_icon {\n  width: 16px;\n  height: 16px;\n}\n\n.partner_loading_container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.partner_loading_spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--color-border);\n  border-top: 3px solid var(--color-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 0.5rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.partner_loading_text {\n  font-size: 0.9rem;\n  color: var(--color-text-secondary);\n}\n\n.partner_table_wrapper {\n  overflow-x: auto;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--color-border);\n}\n\n.partner_table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.partner_table th,\n.partner_table td {\n  border-bottom: 1px solid var(--color-border);\n  padding: 1rem;\n  text-align: center;\n  border-bottom: 1px solid var(--task-border-color);\n}\n\n.partner_table th {\n  background: var(--color-bg-secondary);\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.partner_table tr:hover {\n  background: var(--color-bg-tertiary);\n}\n\n.partner_status_badge {\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.partner_status_badge.active {\n  background: rgb(249 115 22);\n  color: #fdfdfd;\n}\n\n.partner_status_badge.blocked {\n  background: rgba(255, 88, 88, 0.1);\n  color: var(--color-danger);\n}\n\n.partner_action_buttons {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.partner_action_button {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: var(--transition-fast);\n}\n\n.partner_action_button svg {\n  width: 14px;\n  height: 14px;\n}\n\n.partner_edit_button {\n  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */\n  color: #f97316;\n  border: 1px solid #f97316;\n}\n\n.partner_edit_button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.partner_block_button {\n  color: #f97316;\n  border: 1px solid #f97316;\n}\n.partner_unblock_button {\n  /* background: var(--color-danger);\n  color: white; */\n  color: #f97316;\n  border: 1px solid #f97316;\n}\n\n.partner_unblock_button {\n  /* background: var(--color-success); */\n}\n\n.partner_block_button:hover,\n.partner_unblock_button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.partner_no_results {\n  text-align: center;\n  padding: 2rem;\n  color: var(--color-text-secondary);\n  font-size: 0.95rem;\n}\n\n.partner_avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  color: white;\n  font-size: 1rem;\n  font-weight: 600;\n  margin-right: 0.5rem;\n  text-transform: uppercase;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  box-shadow: var(--shadow-sm);\n}\n\n.partner_name_container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.partner_name_text {\n  font-weight: 500;\n  font-size: 0.9rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .partner_table th,\n  .partner_table td {\n    padding: 1rem;\n    text-align: center;\n    border-bottom: 1px solid var(--task-border-color);\n  }\n\n  .partner_action_buttons {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .partner_action_button {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .partner_labour_main_container {\n    padding: 0.5rem;\n  }\n\n  .partner_labour_title {\n    font-size: 1.5rem;\n  }\n\n  .partner_labour_subtitle {\n    font-size: 0.9rem;\n  }\n\n  .Partner_search_add_container {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .form_grid_container {\n    grid-template-columns: 1fr;\n  }\n\n  .Partner_registration_form {\n    margin: 0.5rem;\n    padding: 1rem;\n  }\n\n  .partner_table {\n    font-size: 0.8rem;\n  }\n\n  .partner_table th,\n  .partner_table td {\n    padding: 1rem;\n    text-align: center;\n    border-bottom: 1px solid var(--task-border-color);\n  }\n\n  .partner_table th:nth-child(4),\n  .partner_table td:nth-child(4),\n  .partner_table th:nth-child(5),\n  .partner_table td:nth-child(5) {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .partner_labour_title {\n    font-size: 1.3rem;\n  }\n\n  .partner_labour_subtitle {\n    font-size: 0.85rem;\n  }\n\n  .partner_search_input {\n    padding: 0.6rem 0.6rem 0.6rem 2rem;\n    font-size: 0.85rem;\n  }\n\n  .Partner_add_button {\n    padding: 0.6rem 1rem;\n    font-size: 0.85rem;\n  }\n\n  .partner_table th,\n  .partner_table td {\n    padding: 1rem;\n    text-align: center;\n    border-bottom: 1px solid var(--task-border-color);\n  }\n\n  .partner_table th:nth-child(2),\n  .partner_table td:nth-child(2) {\n    display: none;\n  }\n\n  .partner_action_button {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.75rem;\n  }\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.Partner_registration_form_input.password-input {\n  padding-right: 2.5rem;\n  width: 100%;\n}\n\n.password-toggle-button {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n.password-toggle-icon {\n  color: #6b7280;\n  transition: color 0.2s ease;\n}\n\n.password-toggle-button:hover .password-toggle-icon {\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
